import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const DdosAttackTypeSelector = ({ selectedType = 'bot', onSelectType, disabled = false }) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const handleSelect = (type) => {
    if (disabled) return;
    onSelectType?.(type);
  };

  return (
    <>
      <div className="section-mono-header">
        <div className="section-mono-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect width="18" height="18" x="3" y="3" rx="2" />
            <path d="M3 9h18M9 21V9" />
          </svg>
          <span>{isEn ? 'Attack Type Selection' : 'Выбор типа атаки'}</span>
        </div>
      </div>

      <div className="attack-type-grid">
        {/* 1. DDoS-атака с помощью ботов (L7) */}
        <div
          id="typeCardBot"
          data-type="bot"
          className={`attack-type-card ${selectedType === 'bot' ? 'selected' : ''} ${disabled && selectedType !== 'bot' ? 'disabled' : ''}`}
          onClick={() => handleSelect('bot')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleSelect('bot'); }}
        >
          <svg className="card-watermark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
            <rect width="16" height="12" x="4" y="8" rx="2" />
            <path d="M12 2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2 2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
            <path d="M2 14h2" />
            <path d="M20 14h2" />
            <path d="M15 13v2" />
            <path d="M9 13v2" />
          </svg>

          <div className="type-card-head">
            <div className="type-icon-circle">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <rect width="16" height="12" x="4" y="8" rx="2" />
                <path d="M12 2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2 2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
                <path d="M2 14h2" />
                <path d="M20 14h2" />
                <path d="M15 13v2" />
                <path d="M9 13v2" />
              </svg>
            </div>
            <div className="type-radio-indicator">
              <span className="type-radio-dot" />
            </div>
          </div>

          <div className="type-card-info">
            <span className="type-layer-tag">
              {isEn ? 'L7 • APPLICATION LAYER' : 'L7 • УРОВЕНЬ ПРИЛОЖЕНИЯ'}
            </span>
            <h2 className="type-card-title">
              {isEn ? 'Bot-based DDoS Attack' : 'DDoS-атака с помощью ботов'}
            </h2>
            <p className="type-card-desc">
              {isEn
                ? 'Connecting multiple bot clients to overload server capacity. Depleting authentication processor queues and instance allocated memory.'
                : 'Подключение множества бот-клиентов для перегрузки мощности сервера. Исчерпание процессорных очередей аутентификации и выделенной памяти инстанса.'}
            </p>
          </div>
        </div>

        {/* 2. Пакетная DDoS-атака (L4) */}
        <div
          id="typeCardPacket"
          data-type="packet"
          className={`attack-type-card ${selectedType === 'packet' ? 'selected' : ''} ${disabled && selectedType !== 'packet' ? 'disabled' : ''}`}
          onClick={() => handleSelect('packet')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleSelect('packet'); }}
        >
          <svg className="card-watermark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
          </svg>

          <div className="type-card-head">
            <div className="type-icon-circle">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
              </svg>
            </div>
            <div className="type-radio-indicator">
              <span className="type-radio-dot" />
            </div>
          </div>

          <div className="type-card-info">
            <span className="type-layer-tag">
              {isEn ? 'L4 • TRANSPORT LAYER' : 'L4 • ТРАНСПОРТНЫЙ УРОВЕНЬ'}
            </span>
            <h2 className="type-card-title">
              {isEn ? 'Packet DDoS Attack' : 'Пакетная DDoS-атака'}
            </h2>
            <p className="type-card-desc">
              {isEn
                ? 'Sending high volumes of malformed packets to saturate network bandwidth. Overfilling network buffers, TCP/UDP sockets and exceeding throughput limits.'
                : 'Отправка большого объема некорректных пакетов для перегрузки сети. Заполнение сетевых буферов, сокетов TCP/UDP и превышение лимитов пропускного канала.'}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DdosAttackTypeSelector;
